
export class PRN001Params{
  MEDFeeSection: number;
  IDHidePRN: string;
  BirthdayHidePRN: string;
  ReceiptType: number;
  /** 收據報表代碼 */
  ReceiptCode:string;
  WayCode:string;
  HistoryCode:string;
  RepeatPresCode: string;
  CTRDrugPrintType: string[];
  DailyReportHideCol: string;
  /** @deprecated (已廢除) 請改用 PrintDispPresOption.Itreatnum */
  IsPrintDispPresItreatnum: boolean;
  PrintDispPresOption: string;
  RepeatPresType: number;
  CTRDrugPrintMethod: number;
  DoubleSidedPrintType: number;
  /** 其他收支收據列印類型：0=原版單聯，1=左右雙聯 */
  SalesOrderReceiptPrintType: number;
  /** 其他收支收據紙張：0=原版A5，1=連續報表紙1/2，2=連續報表紙1/3 */
  SalesOrderReceiptPaperType: number;
  ExamPresType: number;
  FontTypeForPrint: number;
  DoubleSidedPrintMedicationWayAndReceipt: boolean;
  DailyReportType: number;
  IsPrintAfterSevenDispPrescription: boolean;
  RegisterCode: string;
  RegisterType: number;
  DailyReportShowPayment: boolean;
  DispExampCode : string;
  CtrDrugsCode: string;
  InjectFormCode : string;
  ReserveCode : string;
  ArrearReceiptCode : string;
  ChineseDetailReceiptCode:string;
  IsPrintDispPresClinic: boolean;
  /** 讀IC卡畫面列印勾選的項目，逗號分隔的 printItems key，由該畫面按列印時寫入 */
  IcViewPrintItems: string;
}

export interface PrintDispPresOptionFlags {
  Itreatnum: boolean;
  RegDateTime: boolean;
  QRCode: boolean;
  Barcode: boolean;
}

export function parsePrintDispPresOption(optionJson?: string): PrintDispPresOptionFlags {
  let option: Partial<PrintDispPresOptionFlags> = {};
  try {
    option = optionJson ? JSON.parse(optionJson) : {};
  } catch {
    option = {};
  }

  return {
    Itreatnum: typeof option?.Itreatnum === 'boolean' ? option.Itreatnum : true,
    RegDateTime: typeof option?.RegDateTime === 'boolean' ? option.RegDateTime : true,
    QRCode: typeof option?.QRCode === 'boolean' ? option.QRCode : true,
    Barcode: typeof option?.Barcode === 'boolean' ? option.Barcode : true
  };
}
